import React, { lazy, Suspense, useContext, useState } from "react";
import makeStyles from "@material-ui/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import WebProfileContext from "@WebProfileContext";
import PageContext from "@PageContext";

const ReactLangSelection = lazy(() =>
	import(
		/* webpackChunkName: "reactLangSelection" */ "@micado-digital/react-lang-selection/ReactLangSelection"
	)
);

const useStyles = makeStyles(theme => ({
	label: {
		color: "#FFFFFF",
		cursor: "pointer",
		fontSize: 18,
		marginTop: -1,
		padding: theme.spacing(1),
		textTransform: "uppercase",
		[theme.breakpoints.up("md")]: {
			padding: theme.spacing(2)
		}
	}
}));

const Language = ({ lang }) => {
	const css = useStyles();
	const [pageData] = useContext(PageContext);
	const { meta } = pageData || {};
	const [profileData] = useContext(WebProfileContext);
	const [languageOpen, setLanguageOpen] = useState(false);

	return profileData?.languages?.length > 1 ? (
		<div className="mco-header__language">
			<Typography className={css.label} onClick={() => setLanguageOpen(true)}>
				{lang}
			</Typography>
			{languageOpen && (
				<Suspense fallback={<></>}>
					<ReactLangSelection
						languages={profileData?.languages}
						currentLanguage={lang}
						links={meta?.links}
						setOverlay={setLanguageOpen}
					/>
				</Suspense>
			)}
		</div>
	) : (
		<></>
	);
};

export default Language;
